import React from "react";
import { useState, useRef, useEffect, useLayoutEffect } from "react";
import { RadioGroup, TextField, Grid, Box, Stack, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "../../utils/fvAxios";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { ToastContainer, toast } from "react-toastify";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { getOrgType } from "../../utils/Token";
import { e } from "mathjs";

export default function UseClientcode({ Vendid }) {
  const navigate = useNavigate();
  const [textareaValue, setTextareaValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [clientname, setClientName] = React.useState('');
  const handleClose = () => {
    setOpen(false);
  };

  const handleTextareaChange = (event) => {
    const newValue = event.target.value;
    setTextareaValue(newValue);
  };
  const handleContinueClick = () => {
    setIsLoading(true);
    axios
      .post(
        "Prequalification/StartQuestionnaireUsingClientCode?clientCode=" +
        textareaValue +
        "&vendorId=" +
        Vendid,
        {
          headers: { "Content-Type": "application/json" },
        }
      )
      .then((res) => {
        if (res?.data?.responseMessage === "Success" && res?.data?.data?.prequalificationId != null) {
          if (res?.data?.data?.errorMessage == "This questionnaire has already been selected" && res?.data?.data?.prequalificationId != null) {
            navigate(
              "/vendordetails?pqid=" + res?.data?.data?.prequalificationId + "&tab=Questionnaire"
            );
          } else {
            if (res?.data?.data?.templates != null) {
              const serializedData = JSON.stringify(res?.data?.data?.templates);
              //navigate("/TemplatesList?startprq=" + serializedData + "&pqid=" + res?.data?.data?.prequalificationId + "&VendorId=" + Vendid + "&copyAns=" + res?.data?.data?.copyAnswers + "&copyDoc=" + false + "&ClientId=" + res?.data?.data?.clientId + "&IsMultiClient=" + res?.data?.data?.isMultiClient + "&CurrentTempID=" + res?.data?.data?.currentTemplateId);

              navigate("/TemplatesList?startprq=" + serializedData + "&pqid=" + res?.data?.data?.prequalificationId + "&CurrentTempID=" + res?.data?.data?.currentTemplateId);
            } else {
              if (
                res?.data?.data.errorMessage ==
                "Questionnaire Locked. Redirect to dashboard"
              ) {
                navigate("/DashBoard");
              } else {
                //navigate("/DashBoard");
                navigate("/vendordetails?pqid=" + res?.data?.data.prequalificationId + "&tab=Questionnaire");
              }
            }
          }
        }
        //Force Template Mapping For All Clients
        else if (res?.data?.data?.templates != null && res?.data?.data.prequalificationId == null) {
          const serializedData = JSON.stringify(res?.data?.data?.templates);
          navigate("/TemplatesList?startprq=" + serializedData + "&pqid=" + res?.data?.data?.prequalificationId + "&VendorId=" + Vendid + "&copyAns=" + res?.data?.data?.copyAnswers + "&copyDoc=" + false + "&ClientId=" + res?.data?.data?.clientId + "&IsMultiClient=" + res?.data?.data?.isMultiClient + "&CurrentTempID=" + res?.data?.data?.currentTemplateId);
        }
        //
        else if (res?.data?.data?.errorMessage.includes("ERI Client")) {
          const parts = res?.data?.data.errorMessage.split("ERI Client -");
          if (parts.length === 2) {
            const clientName = parts[1].trim();
            setClientName(clientName)
            setOpen(true);
          }
          setOpen(true);
        } else if (res?.data?.data?.errorMessage == "Invalid Client Code") {
          toast.error(res?.data?.data?.errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
        else {
          toast.error(res?.data?.responseMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      }
      )
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false); // Set isLoading to false after the API call is completed (either success or error)
      });
  };

  const handleCancleclick = () => {
    navigate("/DashBoard");
  };
  return (
    <>
      <ToastContainer />
      <Dialog
        open={open}
        // onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "706px",
            },
          },
        }}

      >
        <DialogTitle id="alert-dialog-title">

        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {/* <p> The prequalification questionnaire for has been moved under the Insurance Program questionnaire.</p> */}
            <p>1.<span style={{ fontWeight: "bold" }}> If you have previously completed an <span style={{ color: "#0875B1", fontWeight: "bold" }}>Ethanol Producers</span> questionnaire for another client:</span>  Find the listing under “Questionnaires” on the right side of your dashboard. Click either the Complete Missing Items or View Prequalification link.</p>
            <ul>
              <li><p>In the questionnaire, select the new client in the General Information section, add the location in the Locations section (and download one or more PDF guides), and make payment in the Complete Payment section.</p>
              </li>
              <li>
                <p>Upload a certificate of insurance with the client-specific information (guidelines in the PDF you downloaded from the Locations section).</p>

              </li>
            </ul>
            <p>2.<span style={{ fontWeight: "bold" }}> If you have NOT previously completed an <span style={{ color: "#0875B1", fontWeight: "bold" }}>Ethanol Producers</span> questionnaire for another client: </span>Click the “Find clients manually" button at the top of your dashboard, then select the “MULTI-CLIENT QUESTIONNAIRES” tab. Select <span style={{ color: "#0875B1", fontWeight: "bold" }}>Ethanol Producers</span> and click the “Continue” button. Select either the <span style={{ color: "#0875B1", fontWeight: "bold" }}>Safety</span> or the <span style={{ color: "#0875B1", fontWeight: "bold" }}>Low Risk</span> questionnaire, depending on which appears next to <span style={{ color: "#0875B1", fontWeight: "bold" }}>“Risk level”</span> in the invitation you received from the client.</p>

          </DialogContentText>
        </DialogContent>

        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "20px" }}>
          <Button variant="contained" color="primary" onClick={handleClose} sx={{ padding: "19px", width: "160px" }}>Ok</Button>
        </div>

      </Dialog>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Box
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          paddingBottom: "30px",
        }}
      >
        <p hidden={getOrgType() != "Vendor"}>
          Enter Client Code <span style={{ color: "red", fontWeight: "bold" }}>(Required for invitation-only clients.)</span></p>
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          <Grid item xs={12} sm={4} md={4}>
            <p className="mt-2">Code given in Email</p>
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <TextField
              placeholder="Type here"
              name="Type here"
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
                fontFamily: "Arial, FontAwesome",
                width: "320px",
              }}
              variant="outlined"
              size="small"
              value={textareaValue}
              onChange={handleTextareaChange}
            />
          </Grid>
        </Grid>
        <hr style={{ color: "#EAECF0", height: "2px" }} />
        <div style={{ marginBottom: "29px" }}>
          <Stack direction="row" spacing={2} style={{ float: "right" }}>
            <Button
              variant="outlined"
              sx={{ padding: "15px" }}
              onClick={handleCancleclick}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleContinueClick}
              disabled={textareaValue?.length == 0}
            >
              Continue --{">"}
            </Button>
          </Stack>
        </div>
      </Box>
    </>
  );
}
